import { render, staticRenderFns } from "./ValFormInput.vue?vue&type=template&id=4eca50aa&"
import script from "./ValFormInput.vue?vue&type=script&lang=ts&"
export * from "./ValFormInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports